import {
  Breadcrumbs,
  Link,
  TextField,
  Typography,
  withWidth,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import ContactInfoBadge from "../../../Components/Contacts/ContactInfoBadge";
import SortableTable from "../../../Components/SortableTable";
import Title from "../../../Components/Title";
import {
  findValueInText,
  getToken,
  requestErrorHandler,
} from "../../../Utils/Common";
import EnvSettings from "../../../Utils/EnvSettings";
import { useStyles } from "../../../Utils/Styles";

const server = EnvSettings.server;

function Contacts({ width }) {
  const classes = useStyles();
  const history = useHistory();
  const [contactsList, setContactsList] = useState([]);
  const [searchList, setSearchList] = useState();
  const [search, setSearch] = useState();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  let getContacts = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token: getToken(), search_value: "" }),
    };
    fetch(server + "/get_shipping_companies", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          setContactsList(result.companies);
        }
      });
  };
  let showCompany = (id) => {
    history.push("/cpanel/shipments/companies/" + id.id);
  };

  const handleScrollClick = (event, id) => {
    return;
    // if (window.location.href.includes("/cpanel/")) {
    //   window.open("/cpanel/companies/" + id.id, "_blank");
    // }
  };

  const filterResults = () => {
    if (!contactsList) {
      return;
    }
    setSearchList(
      contactsList.filter((contact) => {
        return (
          findValueInText(contact.name, search) ||
          findValueInText(contact.services, search) ||
          findValueInText(contact.services, search, null, (val) => {
            return t("shippingMethods." + val);
          })
        );
      })
    );
  };

  useEffect(getContacts, []);

  useEffect(filterResults, [search, contactsList]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="inherit" href={"/cpanel/shipments"}>
            {t("shipments.header")}
          </Link>

          <Typography color="textPrimary">
            {t("shipments.shippingCompanies")}
          </Typography>
        </Breadcrumbs>
      </Grid>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <TextField
            variant="outlined"
            label={t("search")}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          ></TextField>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Title>{t("companyList.header")}</Title>
          {width === "xs" ? (
            searchList && searchList.length ? (
              searchList
                .sort((a, b) =>
                  a.createdAt > b.createdAt
                    ? -1
                    : b.createdAt > a.createdAt
                    ? 1
                    : 0
                )
                .map((val, i) => (
                  <ContactInfoBadge
                    key={i}
                    clientInfoObject={val}
                    onClick={() => {
                      showCompany(val);
                    }}
                    containerStyles={{ marginTop: 10 }}
                  />
                ))
            ) : null
          ) : searchList ? (
            <SortableTable
              headCells={[
                {
                  id: "name",
                  numeric: false,
                  disablePadding: false,
                  label: t("contactInfo.companyName"),
                },
                {
                  id: "services",
                  numeric: false,
                  disablePadding: false,
                  label: t("shipments.services"),
                },
                {
                  id: "rating",
                  numeric: false,
                  disablePadding: false,
                  label: t("shipments.rating"),
                },
                {
                  id: "etaAccuracy",
                  numeric: false,
                  disablePadding: false,
                  label: t("shipments.etaAccuracy"),
                },
              ]}
              specialDataFormatting={[
                {
                  id: "services",
                  format: (d) => {
                    if (!d) {
                      return "";
                    }
                    return d.map((m) => (
                      <Typography>{t("shippingMethods." + m)}</Typography>
                    ));
                  },
                },
                {
                  id: "rating",
                  format: (d) => {
                    if (!d) {
                      return "";
                    }
                    return d[d.length - 1].toFixed(2);
                  },
                },
                {
                  id: "etaAccuracy",
                  format: (d) => {
                    if (!d) {
                      return "";
                    }
                    var x = Math.round(d[d.length - 1]);
                    return (
                      x +
                      (x > 0
                        ? " " + t("shipments.daysAfter")
                        : " " + t("shipments.daysBefore"))
                    );
                  },
                },
              ]}
              defaultSortRow={"companyName"}
              handleRowClick={showCompany}
              handleScrollClick={handleScrollClick}
              tableData={searchList}
              rowsPerPage={200}
              defaultOrder={"asc"}
            />
          ) : undefined}
        </Paper>
      </Grid>
    </Grid>
  );
}

export default withWidth()(Contacts);
